import angular from 'angular'
import systemParamsCtrl from './systemParamsCtrl'

import {
    systemParams
} from 'redevConfig'


const list = (systemParams && systemParams.list) || ''

const systemParamsListCtrl = list ? require(`redevelopment/system/systemParams/${list.controllerName}`) : require('./systemParamsListCtrl')

const listPage = list ? require(`redevelopment/system/systemParams/${list.templateName}`) : require('./views/systemParams.html')

export default angular
    .module('system.settingcenter.systemParams', [require('angular-sanitize')])
    .config(['$stateProvider', function config($stateProvider) {
        $stateProvider
            .state('system.settingcenter.systemParams', {
                abstract: true,
                url: '/systemParams',
                template: '<div ui-view></div>',
                // controller: 'systemParamsCtrl',
                title: '系统参数',
                default: 'system.settingcenter.systemParams.list',
            })
            .state('system.settingcenter.systemParams.list', {
                url: '/list',
                template: listPage,
                controller: 'systemParamsListCtrl',
            })
    }])
    .controller('systemParamsCtrl', systemParamsCtrl)
    .controller('systemParamsListCtrl', systemParamsListCtrl.default)
    .name



// WEBPACK FOOTER //
// ./src/app/system/settingcenter/systemParams/index.js